import { Link } from "react-router-dom";
import { ShieldCheck, Mail } from "lucide-react";

const PRODUCT_NAME = "Incassi.cloud";
const PRODUCT_SUBTITLE = "Gestione incassi per agenzie assicurative";
const SUPPORT_EMAIL = "info@incassi.cloud";

/**
 * Footer per le pagine PUBBLICHE (landing, /privacy, /termini, /login, /registrazione).
 * NON viene incluso nei Layout dell'area riservata (Admin / Collaborator / Master).
 */
export default function PublicFooter() {
  return (
    <footer className="bg-slate-900 text-slate-400 border-t border-slate-800 py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col gap-4 text-sm">
        {/* Blocco identificativo del titolare — tre righe distinte, testo attenuato */}
        <div className="text-xs text-slate-500 leading-relaxed break-words">
          <div>
            Incassi.cloud è un servizio di <strong className="text-slate-300 font-semibold">Andrea Rossi</strong> — ditta individuale
          </div>
          <div>Via Giuseppe Avanzo 21, 45021 Badia Polesine (RO) — P. IVA 01693010298</div>
          <div>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="hover:text-slate-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
            >
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
        {/* Riga copyright + nav (invariata rispetto all'originale) */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-4 border-t border-slate-800">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-4 h-4 text-blue-400" aria-hidden="true" />
            <span>© {PRODUCT_NAME} · {PRODUCT_SUBTITLE}</span>
          </div>
          <nav className="flex flex-wrap items-center gap-5 justify-center" aria-label="Footer">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded" data-testid="footer-email">
              <Mail className="w-3.5 h-3.5 inline mr-1" aria-hidden="true" /> {SUPPORT_EMAIL}
            </a>
            <Link to="/#contatti" className="hover:text-white">Contatti</Link>
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/termini" className="hover:text-white" data-testid="footer-termini">Termini e condizioni</Link>
            <Link to="/login" className="hover:text-white">Accedi</Link>
            <Link to="/registrazione" className="hover:text-white">Registrati</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
